import { baseApi } from '../baseApi'
import { CreateWalletCodeRes, LoginResponse } from './auth.type'

export const authEndpoints = {
  loginAccount: '/users/login-with-token-id',
  inviteCode: '/users/register-with-invite-code',
  createWalletCode: '/users/create-wallet-account',
}
const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    loginAccount: build.mutation<LoginResponse, string>({
      query: (args) => {
        return {
          url: authEndpoints.loginAccount,
          method: 'POST',
          body: {
            deviceToken: args,
          },
        }
      },
    }),

    createWalletCode: build.mutation<LoginResponse, CreateWalletCodeRes>({
      query: (args) => {
        return {
          url: authEndpoints.createWalletCode,
          method: 'POST',
          body: args,
        }
      },
    }),
  }),
  overrideExisting: false,
})

export const { useLoginAccountMutation, useCreateWalletCodeMutation } = authApi
